// extracted by mini-css-extract-plugin
export default {"SPICellContainer":"SPICell_SPICellContainer__mWJU2","green":"SPICell_green__UfLKx","red":"SPICell_red__OmHzF","orange":"SPICell_orange__Jr7Gq"};